import { Spinner } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

export const LoadingDraftScreen: React.FC<{ title: string }> = ({ title = 'Loading Draft' }) => {
  return (
    <StyledLoadingDraft className="loading-draft">
      <div>
        <Spinner />
        <h2>{title}</h2>
      </div>
    </StyledLoadingDraft>
  );
};

export const StyledLoadingDraft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 132px);
  background-color: ${({ theme }) => theme.colorPalette.gray50};
  mix-blend-mode: normal;
  padding: 10px;

  &.loading-draft {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 20px;
    flex-wrap: wrap;
  }

  &.login-box {
    flex-direction: column;
    background-color: ${({ theme }) => theme.colorPalette.gray50};

    h2 {
      margin-bottom: 1rem;
    }

    > div {
      background-color: ${({ theme }) => theme.colorPalette.white};
      border: solid 1px ${({ theme }) => theme.colors.border};
      border-radius: ${({ theme }) => theme.borderRadius.md};
      box-shadow: ${({ theme }) => theme.shadow.md};
      padding: 2rem;
      width: 100%;
      max-width: 500px;
    }

    .login-auth-box-wrapper {
      width: 100%;
    }

    .forgot-text {
      margin: 0.5rem 0;
    }
  }

  h2 {
    font-size: ${({ theme }) => theme.fontSize['3xl']};
    color: ${({ theme }) => theme.colorPalette.gray800};
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    text-transform: uppercase;
    line-height: 1;
  }

  .spinner {
    flex: unset;
    margin-bottom: 1rem;
    .spinner-icon {
      fill: ${({ theme }) => theme.colorPalette.gray800};
    }
  }
`;
